export default "__VITE_ASSET__BzHXPvGw__"